import { Navigate, Outlet, useLocation } from "react-router";
import { observer } from "mobx-react-lite";
import { useStore } from "../stores/store";

interface Props {
  children?: React.ReactNode;
  invert?: boolean;
  redirectTo?: string;
}

export default observer(function ProtectedRoute({ children, invert = false, redirectTo }: Props) {
  const { userStore } = useStore();
  const location = useLocation();

  if (invert) {
    if (userStore.isLoggedIn) {
      return <Navigate to={redirectTo || "/"} replace />;
    }
  } else {
    if (!userStore.isLoggedIn) {
      // Redirect to login page but save the attempted url
      return <Navigate to={redirectTo || "/login"} state={{ from: location }} replace />;
    }
  }

  if (children) return <>{children}</>;

  return <Outlet />;
});
